import React, {Component} from 'react';
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import Utils from "../../../../../../utils/Utils"
import {withTranslation} from "react-i18next";

class SezioneTre extends Component {

    state = {
        sezioneTre: {
            giallo: "",
            dataInizioMalattia: "",
            ospedalizzatoMalattia: "03",
            giorniOspedalizzato: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.controllaDati = this.controllaDati.bind(this);
        this.createJsonBackend = this.createJsonBackend.bind(this)
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        let segnalazioneCopia = this.props.segnalazioneCopia
        let sezioneTre = this.state.sezioneTre

        let propsSezione = JSON.parse(JSON.stringify(this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sezioneTre ? this.props.segnalazioneCopia.schedaSpeciale.sezioneTre : ""))
        sezioneTre.giallo = propsSezione.giallo ? propsSezione.giallo : ""
        sezioneTre.dataInizioMalattia = propsSezione.dataInizioMalattia ? Utils.transformDateForFrontend(propsSezione.dataInizioMalattia) : segnalazioneCopia && segnalazioneCopia.datiSanitari && segnalazioneCopia.datiSanitari.dataInizioSintomi ? Utils.transformDateForFrontend(segnalazioneCopia.datiSanitari.dataInizioSintomi) : ""
        sezioneTre.ospedalizzatoMalattia = propsSezione.ospedalizzatoMalattia ? propsSezione.ospedalizzatoMalattia : segnalazioneCopia && segnalazioneCopia.datiSanitari && segnalazioneCopia.datiSanitari.ricovero && segnalazioneCopia.datiSanitari.ricovero == "1" ? "01" : segnalazioneCopia && segnalazioneCopia.datiSanitari && segnalazioneCopia.datiSanitari.ricovero && segnalazioneCopia.datiSanitari.ricovero == "2" ? "02" : "03"
        sezioneTre.giorniOspedalizzato = propsSezione.giorniOspedalizzato ? propsSezione.giorniOspedalizzato :
            segnalazioneCopia && segnalazioneCopia.datiSanitari && segnalazioneCopia.datiSanitari.dataRicovero && segnalazioneCopia.datiSanitari.dataDimissione && ((Utils.DateToDays(segnalazioneCopia.datiSanitari.dataDimissione) - Utils.DateToDays(segnalazioneCopia.datiSanitari.dataRicovero)) + 1 ) > 0 ? ((Utils.DateToDays(segnalazioneCopia.datiSanitari.dataDimissione) - Utils.DateToDays(segnalazioneCopia.datiSanitari.dataRicovero)) + 1 ) : ""
        this.setState({SezioneTre: sezioneTre});

        this.controllaDati();
        this.props.setSezioneTre(this.state.sezioneTre)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati()
        if (prevState !== this.state) {
            let res = this.createJsonBackend()
            this.props.setSezioneTre(this.state.sezioneTre, this.validate(), res)
        }
    }

    validate() {

        if (this.state.sezioneTre.dataInizioMalattia) {
            let validatedataInizioMalattia = Utils.checkDateInterval(this.state.sezioneTre.dataInizioMalattia, "31/12/1899");
            let validatedataInizioMalattiaOdierna = Utils.checkDateInterval(this.state.sezioneTre.dataInizioMalattia, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataInizioMalattia) {
                return "Messages.DataInizioMalattia"
            } else if (!validatedataInizioMalattiaOdierna) {
                return "Messages.DataInizioMalattiaOdierna"
            }

        }
        if (this.state.sezioneTre.ospedalizzatoMalattia !== "01" && this.state.sezioneTre.giorniOspedalizzato) return "Messages.ERR_01_02_0D_0O"


        return ""

    }

    createJsonBackend() {
        let dati = JSON.parse(JSON.stringify(this.state.sezioneTre))
        let sezioneBackend = Utils.removeEmptyValueFromObject(dati)
        return Utils.removeFieldFromObject(sezioneBackend, "corretto")
    }

    controllaDati() {

        let dati = this.state.sezioneTre
        dati.corretto = []

        if(!dati.dataInizioMalattia || (dati.dataInizioMalattia !== null && Utils.isDateInValid(Utils.transformDateForBackend(dati.dataInizioMalattia), "-"))) dati.corretto[0] = "Campo \"In che data è iniziata la malattia?\" mancante o errato";
        if(dati.ospedalizzatoMalattia === "01" && !dati.giorniOspedalizzato) dati.corretto[1] = "Campo \"Se sì, quanti giorni è rimasto in ospedale?\" mancante";

    }

    riceviValoreRadioButton(event, field) {
        let sezioneTre = this.state.sezioneTre
        sezioneTre[field] = event

        this.setState({sezioneTre: sezioneTre})
    }

    riceviValoreInput(field, event) {

        let sezioneTre = this.state.sezioneTre
        if (field.currentTarget) {
            sezioneTre[field.currentTarget.id] = field.currentTarget.value
        } else {
            sezioneTre[field] = event.target.value
        }
        this.setState({sezioneTre: sezioneTre})
    }

    render() {

        const {t} = this.props;

        const sezioneTre = (
            <div style={{marginTop: "10px"}}>
                <div>
                    <h6>Sezione 3</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div className="row">
                        <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaEpatite.domandaUno")}</b></p></div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"gialloSi"}
    name={"giallo"} label={t("SchedaEpatite.risposteTipoUno.si")}
    value={"01"}
    onClick={() => this.riceviValoreRadioButton("01", "giallo")}
    checked={this.state.sezioneTre.giallo === "01"}
    />
                                <RadioButton id={"gialloNo"}
    name={"giallo"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "giallo")}
    checked={this.state.sezioneTre.giallo === "02"}
    />
                                <RadioButton id={"gialloNonSO"}
    name={"giallo"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "giallo")}
    checked={this.state.sezioneTre.giallo === "03"}
    />
                            </div>
                        </div>


                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.domandaDue")}</b>
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px"}}>

                            <Calendar
                                id={"dataInizioMalattia"}
                                field={"dataInizioMalattia"}
                                value={this.state.sezioneTre.dataInizioMalattia}
                                onChange={this.riceviValoreInput}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    "Data")}
                                error={(this.state.sezioneTre.dataInizioMalattia === "" ||
                                    this.state.sezioneTre.dataInizioMalattia == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.sezioneTre.dataInizioMalattia), "-")}>

                            </Calendar>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.domandaTre")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"ospedalizzatoMalattiaSI"}
    name={"ospedalizzatoMalattia"}
    label={t("SchedaEpatite.risposteTipoUno.si")}
    value={"01"}
    onClick={() => this.riceviValoreRadioButton("01", "ospedalizzatoMalattia")}
    checked={this.state.sezioneTre.ospedalizzatoMalattia === "01"}
    />
                                <RadioButton id={"ospedalizzatoMalattiaNo"}
    name={"ospedalizzatoMalattia"}
    label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "ospedalizzatoMalattia")}
    checked={this.state.sezioneTre.ospedalizzatoMalattia === "02"}
    />
                                <RadioButton id={"ospedalizzatoMalattiaNonso"}
    name={"ospedalizzatoMalattia"}
    label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "ospedalizzatoMalattia")}
    checked={this.state.sezioneTre.ospedalizzatoMalattia === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.domandaQuattro")}</b>
                                {this.state.sezioneTre.ospedalizzatoMalattia === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-1" style={{paddingLeft: "0px"}}>
                            <Input
                                id={"giorniOspedalizzato"}
                                onChange={this.riceviValoreInput}
                                field={"giorniOspedalizzato"}
                                errorMessage={"sezione non valido"}
                                value={this.state.sezioneTre.giorniOspedalizzato}
                                placeholder={"Giorni"}
                            >
                            </Input>
                        </div>
                    </div>
                </div>
            </div>
        );


        return <div>

            {sezioneTre}
        </div>
    }


}

export default withTranslation('common')(SezioneTre)
